export default {
  methods: {
    compareStrings(str1, str2) {
      const minLength = Math.min(str1.length, str2.length)

      for (let i = 0; i < minLength; i++) {
        if (str1[i] < str2[i]) {
          return false
        } else if (str1[i] > str2[i]) {
          return true
        }
      }

      return str1.length - str2.length > 0
    },
    sortCoinList(arr, isAscending, fieldFn) {
      arr.sort((cur, next) => {
        if (isAscending) {
          if (typeof fieldFn === 'string') {
            return cur[fieldFn] - next[fieldFn]
          } else {
            return this.compareStrings(fieldFn(cur), fieldFn(next)) ? 1 : -1
          }
        } else {
          if (typeof fieldFn === 'string') {
            return next[fieldFn] - cur[fieldFn]
          } else {
            return this.compareStrings(fieldFn(cur), fieldFn(next)) ? -1 : 1
          }
        }
      })
    },
    // 处理点击排序
    handleClickSort(sortObj, module) {
      ;['SET_CONTROL_COIN', 'SET_CONTROL_PRICE', 'SET_CONTROL_UPDOWN'].forEach(
        (item) => {
          if (!sortObj) {
            this.$store.commit(`${module}/${item}`, 0)
          } else {
            const { type, field } = sortObj
            if (type === item) {
              let val = this[field]
              val = val < 2 ? ++val : 0
              this.$store.commit(`${module}/${item}`, val)
            } else {
              this.$store.commit(`${module}/${item}`, 0)
            }
          }
        }
      )
    },
  },
}
